import { FilterChip } from "./FilterChip";
import { Box } from "@mui/material";
import React from "react";

/** A filter kind label followed by the chips of the filters applied for it. */
export const FilterKindOption = ({ label, chips }) => (
  <Box
    component={"span"}
    sx={{
      display: "inline-flex",
      alignItems: "center",
      flexWrap: "nowrap",
      whiteSpace: "nowrap",
      gap: 0.5,
    }}
  >
    <span>{label}</span>
    {(chips ?? []).map((chip) => (
      <FilterChip
        key={chip.key}
        label={chip.label}
        tooltip={chip.tooltip}
        onDelete={chip.onDelete}
      />
    ))}
  </Box>
);
export default FilterKindOption;
